export default [
  {
      path: '/deployment-applications',
      component: () => import('../pages/deployment-applications/Index.vue'),
      children: [
        {
          path: '',
          name: 'deployment-applications/list',
          meta: {
              parentPath: '/deployments',
              layout: 'default',
              breadcrumb: [{ label: 'Applications' }],
          },
          component: () => import('../pages/deployment-applications/Applications.vue'),
      },
      {
          path: 'add',
          name: 'deployment-applications/add',
          meta: {
              parentPath: '/deployments',
              layout: 'default',
              breadcrumb: [{ label: 'Applications', to: { name: 'deployment-applications/list' } }, { label: 'Add Application' }],
          },
          component: () => import('../pages/deployment-applications/AddEditApplication.vue'),
      },
      {
          path: ':id/edit',
          name: 'deployment-applications/edit',
          meta: {
              parentPath: '/deployments',
              layout: 'default',
              breadcrumb: [{ label: 'Applications', to: { name: 'deployment-applications/list' } }, { label: 'Edit Application' }],
          },
          component: () => import('../pages/deployment-applications/AddEditApplication.vue'),
      },
      {
          path: ':id',
          name: 'deployment-applications/detail',
          meta: {
              parentPath: '/deployments',
              layout: 'default',
              breadcrumb: [{ label: 'Applications',  to: { name: 'deployment-applications/list' } }],
          },
          component: () => import('../pages/deployment-applications/ApplicationDetail.vue'),
      }
      ],
  },
];
